module.exports = __webpack_public_path__ + "img/Skirt-Front-B8-Da-Ha-Ia.d642df57.png";